import styled from 'styled-components'
import { mq, vars, createVar } from '@snsw-gel/theming'

export const colSpanVar = createVar('col-span')

export const ColStyled = styled.div`
    padding-left: 0;
    padding-right: 0;

    ${mq.min('tablet')} {
        padding-left: calc(${vars.grid.gutter} / 2);
        padding-right: calc(${vars.grid.gutter} / 2);
        flex-basis: 0;
        flex-grow: 1;
        max-width: calc(${colSpanVar} / ${vars.grid.columns} * 100%);
    }
`
